import styles from "./ui.module.scss";

export default function Skeleton({ type, number }) {
  const SkeletonRoutes = () => (
    <div className={styles.skeleton_routes}>
      {Array.from({ length: Number(number) }, (_, index) => (
        <div key={index} className={styles.skeleton_routesCard}></div>
      ))}
    </div>
  );

  const SkeletonServices = () => (
    <div className={styles.skeleton_services}>
      {Array.from({ length: Number(number) }, (_, index) => (
        <div key={index} className={styles.skeleton_servicesCard}></div>
      ))}
    </div>
  );

  const SkeletonNews = () => (
    <div className={styles.skeleton_news}>
      {Array.from({ length: Number(number) }, (_, index) => (
        <div key={index} className={styles.skeleton_newsCard}></div>
      ))}
    </div>
  );

  const SkeletonusefulLinks = () => (
    <div className={styles.skeleton_usefulLinks}>
      {Array.from({ length: Number(number) }, (_, index) => (
        <div key={index} className={styles.skeleton_usefulLinksCard}></div>
      ))}
    </div>
  );

  if (type === "routes") return <SkeletonRoutes />;
  if (type === "service") return <SkeletonServices />;
  if (type === "news") return <SkeletonNews />;
  if (type === "usefulLinks") return <SkeletonusefulLinks />;
}
